<template>
  <div>
    <button class="d-none" data-toggle="modal" data-target="#manageTeams" ref="openModalManageTeams"></button>
    <div class="modal fade" tabindex="-1" role="dialog" id="manageTeams">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title m-0">Manage Event Teams - {{ eventName }}</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeManageTeams">
              <img src="../../../assets/Svg/close.svg" />
            </button>
          </div>
          <div class="modal-body">
            <div class="teammates-lineup-wrapper manage-team-lineup">
              <div class="available-teammates">
                <h6 class="d-flex flex-wrap align-items-center justify-content-between" style="gap: 5px;">
                  <span>Available Teams</span>
                  <button class="btn manage-btn" @click="checkCurd">Add Team</button>
                </h6>
                <div class="teammates-info overflow-hidden manage-teams">
                  <div class="search-container border-0 mx-2">
                    <form>
                      <button type="button">
                        <img src="../../../assets/images/search.png" alt="" />
                      </button>
                      <input v-model="searchValue" id="search-input" type="text"
                        placeholder="Search by team name or city" name="search" autocomplete="new-password"
                        v-on:keyup.enter="handleSearch" v-on:keyup="debounceSearch" />
                    </form>
                  </div>
                  <draggable class="list-group" :list="availableTeams" group="umpires" handle=".handle"
                    @change="handleAvailableTeams" v-if="availableTeams.length > 0">
                    <div class="list-group-item cursor-none" v-for="(element, index) in availableTeams" :key="index">
                      <div class="shirt-no-wrapper">
                        <small>{{ index + 1 }}.</small>
                        <div class="d-flex flex-column">
                          <p class="name">{{ element.team.team_name }}</p>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.age_group?.name ? element.team.age_group.name + '-' : '' }}
                            {{ element?.team?.team_gender ? element.team.team_gender + '-' : '' }}
                            {{ element?.team?.ratings?.rate }}
                          </small>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.city }},
                            {{ element?.team?.state }}
                          </small>
                        </div>
                      </div>
                      <div class="handle cursor-pointer">
                        <img src="../../../assets/images/line-ellipsis.png" alt=""
                          title="Click an icon to drag and drop the option." />
                      </div>
                    </div>

                    <div v-if="availableTeams.length" v-observe-visibility="handleScrolledToButtom" class="pb-3"></div>
                    <div class="p-3" v-if="showLoaderAvailableTeams == 1">
                      <content-placeholders :rounded="true">
                        <content-placeholders-heading :img="false" />
                      </content-placeholders>
                    </div>

                  </draggable>
                  <div class="no-line-up" v-if="showLoaderAvailableTeams == 0 && availableTeams.length == 0">
                    <div class="img">
                      <img src="../../../assets/images/teammates.png" alt=""
                        title="Click an icon to drag and drop the option." />
                    </div>
                    <p class="text">No available Teams found.</p>
                  </div>
                  <div class="lds-dual-ring-media" v-if="availableTeams.length == 0 && showLoaderAvailableTeams == 1">
                  </div>
                </div>
              </div>
              <div class="team-lineup">
                <h6 style="padding-top: 10px; padding-bottom: 5px;">Teams Selected</h6>
                <div class="teammates-info position-relative teams-selected">

                  <draggable class="list-group" :list="selectedTeams" group="umpires" handle=".handle"
                    @change="handleSelectedTeams" v-if="showLoaderSelectedTeams == 0">
                    <div class="list-group-item cursor-none" v-for="(element, index) in selectedTeams"
                      :key="element?.position_index">
                      <div class="shirt-no-wrapper">
                        <small>{{ index + 1 }}.</small>
                        <div class="d-flex flex-column">
                          <p class="name">{{ element.team.team_name }}</p>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.age_group?.name ? element.team.age_group.name + '-' : '' }}
                            {{ element?.team?.team_gender ? element.team.team_gender + '-' : '' }}
                            {{ element?.team?.ratings?.rate }}
                          </small>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.city }},
                            {{ element?.team?.state }}
                          </small>
                        </div>
                      </div>
                      <div class="handle cursor-pointer">
                        <img src="../../../assets/images/line-ellipsis.png" alt=""
                          title="Click an icon to drag and drop the option." />
                      </div>
                    </div>
                  </draggable>
                  <div class="no-line-up" v-if="showLoaderSelectedTeams == 0 && selectedTeams.length == 0">
                    <div class="img">
                      <img src="../../../assets/images/teammates.png" alt="" />
                    </div>
                    <p class="text">No selected Teams found.</p>
                  </div>
                  <div class="lds-dual-ring-media" v-if="showLoaderSelectedTeams == 1"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="event-btns-wrapper pt-3 justify-content-end">
            <button v-if="!isDisabled" type="button" class="btn btn-primary" @click="manageTeams(0)"
              :disabled="isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save</div>
            </button>
            <button v-else type="button" class="btn btn-primary-disabled" :disabled="isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save</div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <AddTeam />
  </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
import AddTeam from "./AddTeam.vue";
export default {
  name: "ManageTeams",
  components: {
    draggable,
    AddTeam
  },
  props: {
    eventId: {
      type: Number,
      required: true, // <-- must explicitly set to true
    },
    association_id: {
      type: Number,
      default: null, // optional: provide default if not required
    },
    eventName: {
      type: String,
    },
  },
  data() {
    return {
      isDisabled: true,
      isLoadingArray: [],
      selectedTeams: [],
      showLoaderSelectedTeams: 1,
      availableTeams: [],
      showLoaderAvailableTeams: 1,
      searchValue: "",
      page: 1,
      lastPage: 1,
    };
  },
  watch: {
    selectedTeams(newValue) {
      if (newValue.length > 0 || this.availableTeams.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    availableTeams(newValue) {
      if (newValue.length > 0 || this.selectedTeams.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
  },
  computed: {
    filteredAvailableTeams() {
      const lowercasedSearchValue = this.searchValue.toLowerCase();
      return this.availableTeams.filter((team) => {
        const isSelected = this.selectedTeams.some(
          (selected) => selected.team.id === team.team.id
        );
        const teamName = team.team.team_name.toLowerCase();
        const city = (team.team.city || '').toLowerCase();

        return (
          !isSelected &&
          (teamName.includes(lowercasedSearchValue) ||
            city.includes(lowercasedSearchValue))
        );
      });
    },
  },

  methods: {
    closeModal() {
      var elem = this.$refs.closeManageTeams;
      if (elem) {
        elem.click();
      }
    },
    checkCurd() {
      this.$root.$emit("openAddTeamsModal", { eventId: this.eventId, association_id: this.association_id });
      this.closeModal();
    },
    debounceSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 600); // 600ms delay
    },
    handleSearch() {
      this.availableTeams = [];
      this.filteredAvailableTeams = [];
      this.page = 1; // Reset to first page when searching
      this.getTeamsForAssociation();
    },
    handleScrolledToButtom(isVisible) {
      if (this.page >= this.lastPage) {
        return;
      }
      if (isVisible) {
        this.page++;
        this.getTeamsForAssociation();
      }
    },

    async manageTeams(index) {
      if (this.selectedTeams.length === 0) {
        this.$alert('Please select at least one team before saving.', 'Error', {
          confirmButtonText: 'OK',
          type: 'error'
        });
        this.$set(this.isLoadingArray, index, false);
        return; // Exit the function early
      }
      this.$set(this.isLoadingArray, index, true);
      try {
        const url = `${process.env.VUE_APP_API_URL}associationEvent/addTeamsToEvent`;

        // const essentialTeamsData = this.selectedTeams.map(team => ({
        //   team: {
        //     id: team.team.id
        //   }
        // }));
        // const response = await axios.post(url, {
        //   event_id: this.eventId,
        //   selectedTeams: essentialTeamsData,
        // });
        const response = await axios.post(url, {
          event_id: this.eventId,
          selectedTeams: this.selectedTeams,
          association_id: this.association_id,
        });
        if (response.data.statusCode === 200) {
          if (response.data.associatedTeam == 1) {
            this.$alert(response.data.message);
          }

          this.$root.$emit("selectedTeamEmit");
          this.closeModal();
        } else if (response.data.statusCode === 404) {
          this.closeModal();
          this.$alert(response.data.message, 'Error');
          this.$router.push({ name: "Teams" });
        }
      } catch (error) {
        console.error("Error saving selected teams:", error);
      } finally {
        this.$set(this.isLoadingArray, index, false);
      }
    },
    handleAvailableTeams(evt) {
      if (evt.added) {
        const addedTeam = evt.added.element;
        this.selectedTeams.push(addedTeam);
        this.availableTeams = this.availableTeams.filter(team => team.team.id !== addedTeam.team.id);
      }
    },
    handleSelectedTeams(evt) {
      if (evt.removed) {
        const removedTeam = evt.removed.element;
        this.availableTeams.push(removedTeam);
        this.selectedTeams = this.selectedTeams.filter(team => team.team.id !== removedTeam.team.id);
      }
    },
    async getTeamsForAssociation() {
      try {
        this.showLoaderAvailableTeams = 1;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}associationEvent/getTeamsCreatedByAdmin?page=${this.page}&event_id=${this.eventId}&search=${this.searchValue}&association_id=${this.association_id}`
        );

        if (response.data.statusCode === 200) {
          const availableTeamsData = response.data.data;
          const combinedTeams = this.availableTeams.concat(availableTeamsData);

          // Sort after combining
          const sortedTeams = combinedTeams.sort((a, b) => {
            const extractNumber = (str) => parseInt(str.match(/\d+/), 10);
            const isOlder = (str) => str.toLowerCase().includes("older");
            const ageA = a?.team?.age_group?.name || "";
            const ageB = b?.team?.age_group?.name || "";

            const numA = extractNumber(ageA);
            const numB = extractNumber(ageB);

            if (!isOlder(ageA) && !isOlder(ageB)) {
              return numA - numB;
            } else if (isOlder(ageA) && isOlder(ageB)) {
              return numA - numB;
            } else if (!isOlder(ageA) && isOlder(ageB)) {
              return -1;
            } else {
              return 1;
            }
          });

          this.availableTeams = sortedTeams;

          this.showLoaderAvailableTeams = 0;
          this.total = response.data.pagination.total;
          this.lastPage = response.data.pagination.last_page;
        }
        else if (response.data.statusCode === 404) {
          this.closeModal();
          this.$alert(response.data.message, 'Error');
          this.$router.push({ name: "Teams" });
          this.showLoaderAvailableTeams = 0;

        }
        else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderAvailableTeams = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoaderAvailableTeams = 0;
      }
    },
    async getTeamsForEvent() {
      this.showLoaderSelectedTeams = 1;
      try {
        const url = `${process.env.VUE_APP_API_URL}associationEvent/getJoinedTeam?event_id=${this.eventId}&association_id=${this.association_id}`;
        const response = await axios.get(url);
        if (response.data.statusCode === 200) {
          this.selectedTeams = response.data.data;

          // Inline sorting logic
          this.selectedTeams.sort((a, b) => {
            const extractNumber = (str) => parseInt(str.match(/\d+/), 10);
            const isOlder = (str) => str.toLowerCase().includes("older");

            const ageA = a?.team?.age_group?.name || "";
            const ageB = b?.team?.age_group?.name || "";

            const numA = extractNumber(ageA);
            const numB = extractNumber(ageB);

            if (!isOlder(ageA) && !isOlder(ageB)) {
              // Both are U categories
              return numA - numB;
            } else if (isOlder(ageA) && isOlder(ageB)) {
              // Both are Older categories
              return numA - numB;
            } else if (!isOlder(ageA) && isOlder(ageB)) {
              // U category should come before Older category
              return -1;
            } else {
              // Older category should come after U category
              return 1;
            }
          });

          this.showLoaderSelectedTeams = 0;
        } else if (response.data.statusCode === 404) {
          this.closeModal();
          // this.$alert(response.data.message, 'Error');
          this.$router.push({ name: "Teams" });
          this.showLoaderAvailableTeams = 0;

        } else {
          console.error(
            "Failed to fetch teams:",
            response.data.message || "Unknown error occurred"
          );
          this.showLoaderSelectedTeams = 0;
        }
      } catch (error) {
        this.showLoaderSelectedTeams = 0;
        console.error("Failed to fetch teams:", error);
      }
    },
  },
  mounted() {
    this.$root.$on("openManageTeamsModal", ({ eventId, association_id }) => {
      this.eventId = eventId;
      this.association_id = association_id;

      this.searchValue = "";
      this.filteredAvailableTeams = [];
      this.availableTeams = [];
      this.page = 1;
      this.getTeamsForEvent();
      this.getTeamsForAssociation();
      var elem = this.$refs.openModalManageTeams;
      if (elem) {
        elem.click();
      }
    });
  },
};
</script>

<style scoped>
/* Add any relevant styles here */
.manage-teams {
  height: 464px !important;
}
</style>
